import { Button, Card, Col, DatePicker, Form, notification, Row, Space, Tooltip } from 'antd'
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf } from '../../../utils/pdf';
import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined, SearchOutlined } from '@ant-design/icons';
import TableView from '../../../../contents/AntTableResponsive';
import { SelectSession } from '../../../select/SelectSession';
import { SelectClass } from '../../../select/SelectClass';
import { SelectDepartmentByClass } from '../../../select/SelectDepartmentByClass';
import { SelectSemesterYearByClass } from '../../../select/SelectSemesterYearByClass';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



export default function StudentFeeheadDueDetails(props) {

    const showStudentFeeHeadDue = useStoreState((state) => state.payslip.showStudentFeeHeadDue2);
    const feeHeadNames = useStoreState((state) => state.payslip.feeHeadNames);
    const fetchshowStudentFeeHeadDue = useStoreActions((state) => state.payslip.fetchshowStudentFeeHeadDue2);
    const fetchdepartmentListByClassId = useStoreActions((state) => state.common.fetchdepartmentListByClassId);
    const fetchsessionYearListByClassId = useStoreActions((state) => state.common.fetchsessionYearListByClassId);
    const [selectedClass, setSelectedClass] = useState<any>();
    const [selectedSemesterYear, setSelectedSemesterYear] = useState<any>();
    const [selectedDepartment, setselectedDepartment] = useState<any>();
    const [reportForm] = Form.useForm();

    const reportFormSubmit = (value) => {


        value.fromDate = moment(value?.fromDate).format("YYYY-MM-DD");
        value.toDate = moment(value?.toDate).format("YYYY-MM-DD");
        fetchshowStudentFeeHeadDue(value);
    };

//console.log(showStudentFeeHeadDue)
const [columns, setcolumns] = useState<any>([]);
const [excelx, setexcelx] = useState<any>([]);

    useEffect(() => {

        if (showStudentFeeHeadDue?.studentList?.length > 0) {
            setcolumns([{
                title: 'Student Id',
                dataIndex: 'customStudentId',
                key: 'customStudentId',
                showOnResponse: true,
                showOnDesktop: true,
            },

            {
                title: 'Student Name',
                dataIndex: 'studentName',
                key: 'studentName',
                showOnResponse: true,
                showOnDesktop: true,
            },
            {
                title: 'Roll',
                dataIndex: 'studentRoll',
                key: 'studentRoll',
                showOnResponse: true,
                showOnDesktop: true,
            },            
            {
                title: 'Total Payable',
                dataIndex: 'totalPayable',
                key: 'totalPayable',
                showOnResponse: true,
                showOnDesktop: true,
            },
 
            ]);


        }

    }, [showStudentFeeHeadDue])



    return (
        <>

            <Form
                layout="vertical"
                onFinish={reportFormSubmit}
                id="basic-info"
                form={reportForm}
            >
                <Row gutter={8}>
                    <Col xs={24} sm={24} md={24} lg={1} xl={1}></Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="sessionId"
                            label="Session"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select session" },
                            ]}
                        >

                            <SelectSession />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="classId"
                            label="Class"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select class" },
                            ]}
                        >

                            <SelectClass selected={selectedClass} onChange={(e) => { fetchsessionYearListByClassId(e); fetchdepartmentListByClassId(e); setSelectedClass(e); setselectedDepartment(null); setSelectedSemesterYear(null) }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="departmentId"
                            label="Department"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select department" },
                            ]}
                        >
                            <SelectDepartmentByClass selected={selectedDepartment} onChange={(e) => { setselectedDepartment(e) }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="semesterId"
                            label="Semester Year"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select semester year" },
                            ]}
                        >

                            <SelectSemesterYearByClass selected={selectedSemesterYear} onChange={(e) => { setSelectedSemesterYear(e) }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={0} xl={0}></Col>
                   
                    <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                        <Space size="small" >
                            <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                Search
                            </Button>
                        </Space>
                    </Col>

                </Row>
            </Form>
            {showStudentFeeHeadDue !== null &&
                <>
                    <div className="datatable-responsive">
                        {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} className="p-datatable-responsive-demo" /> */}

                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns,
                                dataSource: showStudentFeeHeadDue?.studentList,
                                pagination: true,
                                bordered: true,
                                rowKey: "identificationId",
                            }}
                            mobileBreakPoint={768}
                        />
                    </div>
                    <Space size="middle" style={{ float: "right", marginTop: 15 }}>

                        <ExcelFile filename="Student Fee Head Due Details"  element={<Button type="primary" icon={<FileExcelOutlined />} >Download Excel</Button>}>
                            <ExcelSheet data={showStudentFeeHeadDue?.studentList} name="Data">
                                <ExcelColumn label="Student Id" value="customStudentId" />
                                <ExcelColumn label="Student Name" value="studentName" />
                                <ExcelColumn label="Roll" value="studentRoll" />
                                <ExcelColumn label="Session" value="session" />
                                <ExcelColumn label="Class" value="className" />
                                <ExcelColumn label="Department" value="department" />
                                <ExcelColumn label="Semester" value="semester" />
                                <ExcelColumn label="Total Payable" value="totalPayable" />
                            </ExcelSheet>
                        </ExcelFile>

                    </Space>
                </>
            }

        </>
    )
}
